import $ from 'jquery';
import showMessage from '../utils/messages';


$.ajaxPrefilter((options, originalOptions) => {
  if (!options.noCsrf && 'method' in options && options.method.toUpperCase() === 'POST') {
    let csrfToken = {
      csrfmiddlewaretoken () {
        return templateData('csrfToken');
      },
    };
    options.data = $.param($.extend(originalOptions.data, csrfToken));
  }
});

$(document).ajaxError((_, {statusText, responseText}) => {
  if (statusText === 'Forbidden' && responseText === 'INADEQUATE_PERMISSIONS') {
    showMessage('You do not have adequate permissions to do that.', 'danger');
  }
});

// Set jQuery on global so it is usable by older modules
global.$ = global.jQuery = $; // eslint-disable-line no-multi-assign
